(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[10],{

/***/ "+vld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("HaE+");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ODXe");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _elements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("9aJQ");
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("0G56");
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("Sk/v");
/* harmony import */ var _material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("SNP2");
/* harmony import */ var _material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _material_ui_core_DialogContentText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("/xgX");
/* harmony import */ var _material_ui_core_DialogContentText__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_DialogContentText__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _material_ui_core_DialogTitle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("C+zi");
/* harmony import */ var _material_ui_core_DialogTitle__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_material_ui_core_DialogTitle__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _services_listingService__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("dYvW");
/* harmony import */ var _utils_ui__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("PdCH");
/* harmony import */ var _helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("tkT3");
/* harmony import */ var _helpers_google_tag_manager_events_homepage__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("XsDQ");
/* harmony import */ var _helpers_google_tag_manager_events_listing_search__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("/n9I");
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("KNqG");
/* harmony import */ var _helpers_google_tag_manager__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__("kqSB");
/* harmony import */ var _helpers_id_creator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__("I5Nt");
/* harmony import */ var _helpers_id_creator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_helpers_id_creator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _helpers_google_tag_manager_get_search_id__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__("1xxY");
/* harmony import */ var _helpers_google_tag_manager_events_listing_detail__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__("UYDH");
/* harmony import */ var _helpers_google_tag_manager_utils__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__("hA9m");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__("jG6q");
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_22__);




var __jsx = react__WEBPACK_IMPORTED_MODULE_4___default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




















/**
 * @param listingOwnerPhone
 * @param style
 * @param page
 * @param listingId
 * @param isSmall if the button width is smaller than 150 px add this param for better view
 */

var ShowPhone = function ShowPhone(_ref) {
  var listingOwnerPhone = _ref.listingOwnerPhone,
      clearPhoneNumber = _ref.clearPhoneNumber,
      style = _ref.style,
      _ref$page = _ref.page,
      page = _ref$page === void 0 ? 'LISTING_LIST' : _ref$page,
      listingId = _ref.listingId,
      listing = _ref.listing,
      dataRoad = _ref.dataRoad,
      itemIndex = _ref.itemIndex,
      _ref$isSmall = _ref.isSmall,
      isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
      _ref$isProject = _ref.isProject,
      isProject = _ref$isProject === void 0 ? false : _ref$isProject,
      gtmEventLabel = _ref.gtmEventLabel,
      _ref$withoutViewCount = _ref.withoutViewCount,
      withoutViewCount = _ref$withoutViewCount === void 0 ? false : _ref$withoutViewCount,
      price = _ref.price,
      pageNumber = _ref.pageNumber,
      activeListingIndex = _ref.activeListingIndex;
  var ownerPhone = listingOwnerPhone;

  if (clearPhoneNumber && listingOwnerPhone && listingOwnerPhone.startsWith('+9')) {
    ownerPhone = listingOwnerPhone.split('+9')[1];
  }

  var formattedPhone = Object(_utils_ui__WEBPACK_IMPORTED_MODULE_12__[/* formatPhoneView */ "a"])(ownerPhone);

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_4___default.a.useState(null),
      _React$useState2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_React$useState, 2),
      phone = _React$useState2[0],
      setPhone = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_4___default.a.useState(false),
      _React$useState4 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(_React$useState3, 2),
      isErrorOpen = _React$useState4[0],
      setIsErrorOpen = _React$useState4[1];

  var checkName = function checkName(str) {
    if (!str) return undefined;
    if (str.name) return Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_16__[/* slugify */ "i"])(str.name);
    return str.slug;
  };

  var checkPrice = function checkPrice() {
    if (!price) return undefined;
    if (price.value) return price.value.toString();
    if (price.price) return price.price.toString();
    return price.toString();
  };

  var setga4PhoneEvent = function setga4PhoneEvent() {
    var eventName = phone ? 'call' : 'view_phone';
    var itemType = isProject ? 'proje' : 'ilan';
    var location = (listing === null || listing === void 0 ? void 0 : listing.location) || {}; // because: Get the information on which page the user send the event

    var pageTypeEquals = {
      listeleme: 'ilan-listeleme',
      'emlak-ofisleri': 'ilan-listeleme',
      'one-cikan-ilanlar': 'anasayfa',
      detay: 'ilan-detay'
    };
    var pageTypeForGa4Event = pageTypeEquals[gtmEventLabel] || gtmEventLabel;
    var eventParameters = {
      page_type: pageTypeForGa4Event,
      ilan_fiyat: checkPrice(),
      item_id: listingId === null || listingId === void 0 ? void 0 : listingId.toString(),
      item_type: itemType,
      city: checkName(location === null || location === void 0 ? void 0 : location.city),
      town: checkName(location === null || location === void 0 ? void 0 : location.district),
      neighborhood: checkName(location === null || location === void 0 ? void 0 : location.town),
      district: checkName(location === null || location === void 0 ? void 0 : location.locality)
    };
    if (!phone) eventParameters.view_count = 1;
    Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_13__[/* formGTMEventGA4 */ "o"])({
      eventName: eventName,
      eventParameters: eventParameters
    });
  };

  var setGa4EventForLandPage = function setGa4EventForLandPage() {
    var _listing$priceDetail, _listing$price, _listing$currency;

    var currency = ((_listing$priceDetail = listing.priceDetail) === null || _listing$priceDetail === void 0 ? void 0 : _listing$priceDetail.currency) || (listing === null || listing === void 0 ? void 0 : (_listing$price = listing.price) === null || _listing$price === void 0 ? void 0 : _listing$price.currency) || (listing === null || listing === void 0 ? void 0 : (_listing$currency = listing.currency) === null || _listing$currency === void 0 ? void 0 : _listing$currency.symbol) || (listing === null || listing === void 0 ? void 0 : listing.currency);
    Object(_helpers_google_tag_manager_get_search_id__WEBPACK_IMPORTED_MODULE_19__["default"])('land').then(function (searchId) {
      var affiliation = phone ? 'call' : 'view_phone';
      var tabNameEquals = {
        0: 'fiyati-dusenler',
        1: 'sahibinden',
        2: 'altyapisi-hazir',
        3: 'en-yeniler',
        4: 'sanal-turlu-videolu'
      };
      Object(_helpers_google_tag_manager__WEBPACK_IMPORTED_MODULE_17__[/* GTMPushEvent */ "a"])({
        event: 'purchase',
        ecommerce: {
          transaction_id: _helpers_id_creator__WEBPACK_IMPORTED_MODULE_18___default()(32),
          affiliation: affiliation,
          value: 0.0,
          tax: 0.0,
          shipping: 0.0,
          currency: currency,
          items: Object(_helpers_google_tag_manager_utils__WEBPACK_IMPORTED_MODULE_21__[/* generateGa4EcommerceLandListingData */ "a"])({
            item: listing,
            index: itemIndex + 1,
            searchId: searchId,
            affiliation: affiliation,
            listName: "arsa-ilanlari/".concat(tabNameEquals[activeListingIndex]),
            listIdName: 'arsa-ilanlari',
            tabName: tabNameEquals[activeListingIndex]
          })
        }
      });
    });
  };

  var onHandleClick = /*#__PURE__*/function () {
    var _ref2 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(event) {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                setPhone(formattedPhone);
              } catch (e) {
                setIsErrorOpen(true);
              }

              setga4PhoneEvent(event);

              if (!isProject && !phone) {
                Object(_services_listingService__WEBPACK_IMPORTED_MODULE_11__[/* handleViewPhoneEvent */ "p"])(listingId, gtmEventLabel === 'listeleme' ? 'listing_list' : 'listing_detail');
              }

              Object(_helpers_google_tag_manager_events__WEBPACK_IMPORTED_MODULE_13__[/* phoneGTMEvent */ "N"])({
                label: gtmEventLabel,
                listingId: listingId,
                listingPrice: (price === null || price === void 0 ? void 0 : price.price) || (price === null || price === void 0 ? void 0 : price.value)
              }, withoutViewCount);
              /* GTM Events */

              _context.t0 = gtmEventLabel;
              _context.next = _context.t0 === 'listeleme' ? 7 : _context.t0 === 'one-cikan-ilanlar' ? 9 : _context.t0 === 'emlak-ofisleri' ? 11 : _context.t0 === 'emlak-ofisi-detay' ? 13 : _context.t0 === 'detay' ? 15 : _context.t0 === 'harita' ? 17 : _context.t0 === 'galeri' ? 19 : _context.t0 === 'karsilastir' ? 21 : _context.t0 === 'arsa-dunyasi' ? 23 : _context.t0 === 'jetfirsat' ? 25 : 27;
              break;

            case 7:
              Object(_helpers_google_tag_manager_events_listing_search__WEBPACK_IMPORTED_MODULE_15__["listingPhoneCallGtmEvent"])(listing, itemIndex, pageNumber);
              return _context.abrupt("break", 28);

            case 9:
              Object(_helpers_google_tag_manager_events_homepage__WEBPACK_IMPORTED_MODULE_14__["homePhoneCallGtmEvent"])(listing, itemIndex, 'ana-sayfa');
              return _context.abrupt("break", 28);

            case 11:
              Object(_helpers_google_tag_manager_events_homepage__WEBPACK_IMPORTED_MODULE_14__["homePhoneCallGtmEvent"])(listing, itemIndex, 'emlak-ofisleri');
              return _context.abrupt("break", 28);

            case 13:
              Object(_helpers_google_tag_manager_events_listing_detail__WEBPACK_IMPORTED_MODULE_20__["agentDetailShowPhoneGTMEvent"])(event, listing, itemIndex, pageNumber, 'telefon-et');
              return _context.abrupt("break", 28);

            case 15:
              if (dataRoad === 'dataFromListingDetail') {
                Object(_helpers_google_tag_manager_events_listing_detail__WEBPACK_IMPORTED_MODULE_20__["listingDetailShowPhoneGtmEvent"])(listing, 'emlakci');
              } else if (dataRoad === 'dataFromQuickMenu') {
                Object(_helpers_google_tag_manager_events_listing_detail__WEBPACK_IMPORTED_MODULE_20__["listingDetailShowPhoneGtmEvent"])(listing, 'sticky-header');
              }

              return _context.abrupt("break", 28);

            case 17:
              Object(_helpers_google_tag_manager_events_listing_detail__WEBPACK_IMPORTED_MODULE_20__["listingDetailShowPhoneGtmEvent"])(listing, 'map');
              return _context.abrupt("break", 28);

            case 19:
              Object(_helpers_google_tag_manager_events_listing_detail__WEBPACK_IMPORTED_MODULE_20__["listingDetailShowPhoneGtmEvent"])(listing, 'gallery');
              return _context.abrupt("break", 28);

            case 21:
              Object(_helpers_google_tag_manager_events_listing_detail__WEBPACK_IMPORTED_MODULE_20__["compareShowPhoneAndShareGTMEvent"])(event, listing, itemIndex, 'telefon-et');
              return _context.abrupt("break", 28);

            case 23:
              setGa4EventForLandPage();
              return _context.abrupt("break", 28);

            case 25:
              Object(_helpers_google_tag_manager__WEBPACK_IMPORTED_MODULE_17__[/* GTMPushEvent */ "a"])({
                event: 'ga4_event',
                event_name: 'view_phone',
                event_parameters: {
                  item_list_name: 'jetfirsat-ara-modul'
                }
              });
              return _context.abrupt("break", 28);

            case 27:
              return _context.abrupt("break", 28);

            case 28:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onHandleClick(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleClose = function handleClose() {
    setIsErrorOpen(false);
  };

  var errorDialog = __jsx(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_6___default.a, {
    open: isErrorOpen,
    onClose: handleClose,
    "aria-labelledby": "responsive-dialog-title"
  }, __jsx(_material_ui_core_DialogTitle__WEBPACK_IMPORTED_MODULE_10___default.a, {
    id: "responsive-dialog-title"
  }, "\u0130lan veren telefon bilgisi mevcut de\u011Fil"), __jsx(_material_ui_core_DialogContent__WEBPACK_IMPORTED_MODULE_8___default.a, null, __jsx(_material_ui_core_DialogContentText__WEBPACK_IMPORTED_MODULE_9___default.a, null, "Kullan\u0131c\u0131ya mesaj g\xF6ndererek ileti\u015Fime ge\xE7ebilirsiniz..")), __jsx(_material_ui_core_DialogActions__WEBPACK_IMPORTED_MODULE_7___default.a, null, __jsx(_elements__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "b"], {
    onClick: handleClose,
    color: "red"
  }, "Kapat"), __jsx(_elements__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "b"], {
    color: "primary",
    onClick: handleClose
  }, "Mesaj G\xF6nder")));

  react__WEBPACK_IMPORTED_MODULE_4___default.a.useEffect(function () {
    setPhone(null);
  }, [listingOwnerPhone]);
  return __jsx(react__WEBPACK_IMPORTED_MODULE_4___default.a.Fragment, null, phone ? __jsx("a", {
    href: phone.length === 11 ? "tel:+9".concat(phone) : "tel:".concat(phone),
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default.a.button
  }, __jsx(_elements__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "b"], {
    primary: true,
    style: _objectSpread({
      width: '100%'
    }, style),
    onClick: onHandleClick
  }, phone)) : __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default.a.button
  }, __jsx(_elements__WEBPACK_IMPORTED_MODULE_5__[/* Button */ "b"], {
    primary: true,
    style: _objectSpread({
      width: '100%'
    }, style),
    onClick: onHandleClick
  }, __jsx("div", null, isSmall ? __jsx(react__WEBPACK_IMPORTED_MODULE_4___default.a.Fragment, null, __jsx("img", {
    src: "/static/icons/phone.svg",
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default.a.phoneIcon,
    alt: "phone"
  }), __jsx("div", {
    className: _styles_module_scss__WEBPACK_IMPORTED_MODULE_22___default.a.small
  }, "Telefona Bak")) : __jsx(react__WEBPACK_IMPORTED_MODULE_4___default.a.Fragment, null, "Telefona Bak")))), errorDialog);
};

ShowPhone.defaultProps = {
  clearPhoneNumber: false
};
/* harmony default export */ __webpack_exports__["a"] = (ShowPhone);

/***/ }),

/***/ "/n9I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingInitialGTMEvent", function() { return listingInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectListingItemGA4Event", function() { return selectListingItemGA4Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleListingGtmEvent", function() { return handleListingGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingPhoneCallGtmEvent", function() { return listingPhoneCallGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingAddFavoriteGtmEvent", function() { return listingAddFavoriteGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "projectInitialGTMEvent", function() { return projectInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapInitialGTMEvent", function() { return mapInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingsViewedGtmEvent", function() { return listingsViewedGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "similarListingsViewedGtmEvent", function() { return similarListingsViewedGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listingsProjectCardsViewedGtmEvent", function() { return listingsProjectCardsViewedGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleListingProjectGtmEvent", function() { return handleListingProjectGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "agentSearchInitialGTMEvent", function() { return agentSearchInitialGTMEvent; });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kqSB");
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("joZL");
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_convert_to_url__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("I5Nt");
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_id_creator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("hA9m");
/* harmony import */ var _handleGA4UndefinedValues__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("9oOR");







var getPriceForProjects = function getPriceForProjects(item) {
  var _item$price, _item$price2, _item$price4;

  var data = '';

  if (((_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.priceVisibility) === 'ASK') {
    data = '0.00';
  } else if (((_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : _item$price2.priceVisibility) === 'STARTCOUNT') {
    var _item$price3, _item$price3$startPri;

    data = "".concat(item === null || item === void 0 ? void 0 : (_item$price3 = item.price) === null || _item$price3 === void 0 ? void 0 : (_item$price3$startPri = _item$price3.startPrice) === null || _item$price3$startPri === void 0 ? void 0 : _item$price3$startPri.toFixed(2));
  } else if (((_item$price4 = item.price) === null || _item$price4 === void 0 ? void 0 : _item$price4.priceVisibility) === 'RANGE') {
    var _item$price5, _item$price6;

    data = "".concat(item === null || item === void 0 ? void 0 : (_item$price5 = item.price) === null || _item$price5 === void 0 ? void 0 : _item$price5.minPrice.toFixed(2), " - ").concat(item === null || item === void 0 ? void 0 : (_item$price6 = item.price) === null || _item$price6 === void 0 ? void 0 : _item$price6.maxPrice.toFixed(2));
  }

  return data;
};
/*
 Listings Initial Event
 */


var listingInitialGTMEvent = function listingInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
var selectListingItemGA4Event = function selectListingItemGA4Event(_ref) {
  var item = _ref.item,
      index = _ref.index,
      searchId = _ref.searchId,
      listName = _ref.listName,
      similarStatus = _ref.similarStatus;
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'select_item',
    ecommerce: {
      items: [Object(_utils__WEBPACK_IMPORTED_MODULE_3__[/* generateGa4EcommerceListingItem */ "b"])({
        item: item,
        index: index,
        searchId: searchId,
        listName: listName,
        similarStatus: similarStatus
      })]
    }
  });
};
/*
when clicked in listing listing
*/

var handleListingGtmEvent = function handleListingGtmEvent(listing, itemIndex, label, type) {
  var _listing$location, _listing$location$cit, _listing$location2, _listing$location2$di, _listing$location3, _listing$location3$to, _listing$priceDetail, _listing$priceDetail$, _listing$price, _listing$price$value;

  var categoryPath = "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(((_listing$location = listing.location) === null || _listing$location === void 0 ? void 0 : (_listing$location$cit = _listing$location.city) === null || _listing$location$cit === void 0 ? void 0 : _listing$location$cit.name) || ''), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listing$location2 = listing.location) === null || _listing$location2 === void 0 ? void 0 : (_listing$location2$di = _listing$location2.district) === null || _listing$location2$di === void 0 ? void 0 : _listing$location2$di.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listing$location3 = listing.location) === null || _listing$location3 === void 0 ? void 0 : (_listing$location3$to = _listing$location3.town) === null || _listing$location3$to === void 0 ? void 0 : _listing$location3$to.name));
  var getSearchId = JSON.parse(localStorage.getItem('EjGtmId'));
  var searchId = type === 'ilan listeleme' ? getSearchId.listingsearch : getSearchId.favoriteListDetail;
  var variantEl = type === 'ilan listeleme' ? _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.tradeTypeName) : _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.tradeType);
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: label,
    ecommerce: {
      click: {
        actionField: {
          list: type
        },
        products: [{
          id: "".concat(listing === null || listing === void 0 ? void 0 : listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.title.trim()),
          brand: 'ilan',
          variant: variantEl,
          category: categoryPath,
          position: itemIndex,
          dimension13: searchId,
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail = listing.priceDetail) === null || _listing$priceDetail === void 0 ? void 0 : (_listing$priceDetail$ = _listing$priceDetail.price) === null || _listing$priceDetail$ === void 0 ? void 0 : _listing$priceDetail$.toFixed(2)) || (listing === null || listing === void 0 ? void 0 : (_listing$price = listing.price) === null || _listing$price === void 0 ? void 0 : (_listing$price$value = _listing$price.value) === null || _listing$price$value === void 0 ? void 0 : _listing$price$value.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when listing look at phone  clicked
 */

var listingPhoneCallGtmEvent = function listingPhoneCallGtmEvent(listing, itemIndex) {
  var _listing$location4, _listing$location4$ci, _listing$location5, _listing$location5$di, _listing$location6, _listing$location6$to, _JSON$parse, _listing$priceDetail2, _listing$priceDetail3;

  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'ilan-listeleme',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'ilan-listeleme',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_2___default()(32),
          affiliation: 'telefon-et',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.tradeTypeName),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listing.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listing$location4 = listing.location) === null || _listing$location4 === void 0 ? void 0 : (_listing$location4$ci = _listing$location4.city) === null || _listing$location4$ci === void 0 ? void 0 : _listing$location4$ci.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listing$location5 = listing.location) === null || _listing$location5 === void 0 ? void 0 : (_listing$location5$di = _listing$location5.district) === null || _listing$location5$di === void 0 ? void 0 : _listing$location5$di.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listing$location6 = listing.location) === null || _listing$location6 === void 0 ? void 0 : (_listing$location6$to = _listing$location6.town) === null || _listing$location6$to === void 0 ? void 0 : _listing$location6$to.name)),
          position: itemIndex,
          quantity: 1,
          dimension13: (_JSON$parse = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.listingsearch,
          dimension40: listing.createdAt,
          dimension41: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail2 = listing.priceDetail) === null || _listing$priceDetail2 === void 0 ? void 0 : (_listing$priceDetail3 = _listing$priceDetail2.price) === null || _listing$priceDetail3 === void 0 ? void 0 : _listing$priceDetail3.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
when click add to favorite on listing
*/

var listingAddFavoriteGtmEvent = function listingAddFavoriteGtmEvent(listingItem, itemIndex) {
  var _listingItem$location, _listingItem$location2, _listingItem$location3, _listingItem$location4, _listingItem$location5, _listingItem$location6, _JSON$parse2, _listingItem$priceDet, _listingItem$priceDet2;

  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: 'ilan-listeleme',
    ecommerce: {
      purchase: {
        actionField: {
          list: 'ilan-listeleme',
          id: _id_creator__WEBPACK_IMPORTED_MODULE_2___default()(32),
          affiliation: 'favoriler',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listingItem.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listingItem.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listingItem.tradeTypeName),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listingItem.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(listingItem.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listingItem$location = listingItem.location) === null || _listingItem$location === void 0 ? void 0 : (_listingItem$location2 = _listingItem$location.city) === null || _listingItem$location2 === void 0 ? void 0 : _listingItem$location2.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listingItem$location3 = listingItem.location) === null || _listingItem$location3 === void 0 ? void 0 : (_listingItem$location4 = _listingItem$location3.district) === null || _listingItem$location4 === void 0 ? void 0 : _listingItem$location4.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_listingItem$location5 = listingItem.location) === null || _listingItem$location5 === void 0 ? void 0 : (_listingItem$location6 = _listingItem$location5.town) === null || _listingItem$location6 === void 0 ? void 0 : _listingItem$location6.name)),
          position: itemIndex,
          quantity: 1,
          dimension13: (_JSON$parse2 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.listingsearch,
          dimension40: listingItem.createdAt,
          dimension41: (listingItem === null || listingItem === void 0 ? void 0 : (_listingItem$priceDet = listingItem.priceDetail) === null || _listingItem$priceDet === void 0 ? void 0 : (_listingItem$priceDet2 = _listingItem$priceDet.price) === null || _listingItem$priceDet2 === void 0 ? void 0 : _listingItem$priceDet2.toFixed(2)) || '0.00'
        }]
      }
    }
  });
};
/*
 Project Initial Event
 */

var projectInitialGTMEvent = function projectInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
 Map Initial Event
 */

var mapInitialGTMEvent = function mapInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
when listing card viewed for scroll
*/

var listingsViewedGtmEvent = function listingsViewedGtmEvent(listings) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: 'ilan-listeleme',
    ecommerce: {
      impressions: listings.map(function (item) {
        var _item$location, _item$location$city, _item$location2, _item$location2$distr, _item$location3, _item$location3$town, _JSON$parse3, _item$priceDetail, _item$priceDetail$pri;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(item.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(item.tradeTypeName),
          list: 'ilan-listeleme',
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(item.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(item.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_item$location = item.location) === null || _item$location === void 0 ? void 0 : (_item$location$city = _item$location.city) === null || _item$location$city === void 0 ? void 0 : _item$location$city.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_item$location2 = item.location) === null || _item$location2 === void 0 ? void 0 : (_item$location2$distr = _item$location2.district) === null || _item$location2$distr === void 0 ? void 0 : _item$location2$distr.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_item$location3 = item.location) === null || _item$location3 === void 0 ? void 0 : (_item$location3$town = _item$location3.town) === null || _item$location3$town === void 0 ? void 0 : _item$location3$town.name)),
          position: item.position,
          dimension13: (_JSON$parse3 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.listingsearch,
          dimension40: item.createdAt,
          dimension41: (_item$priceDetail = item.priceDetail) === null || _item$priceDetail === void 0 ? void 0 : (_item$priceDetail$pri = _item$priceDetail.price) === null || _item$priceDetail$pri === void 0 ? void 0 : _item$priceDetail$pri.toFixed(2)
        };
      })
    }
  });
};
var similarListingsViewedGtmEvent = function similarListingsViewedGtmEvent(params) {
  params.forEach(function (listing) {
    Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
      ecommerce: null
    });
    Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
      event: "view_item_list",
      ecommerce: {
        items: Object(_utils__WEBPACK_IMPORTED_MODULE_3__[/* generateGa4EcommerceSimilarListingItem */ "d"])({
          listing: listing,
          listName: 'benzer-ilanlar',
          index: listing.position
        })
      }
    });
  });
};
/*
when project card viewed for scroll
*/

var listingsProjectCardsViewedGtmEvent = function listingsProjectCardsViewedGtmEvent(projects, label) {
  var _JSON$parse4, _JSON$parse5;

  var dimension13 = label ? (_JSON$parse4 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse4 === void 0 ? void 0 : _JSON$parse4.projectsearch : (_JSON$parse5 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse5 === void 0 ? void 0 : _JSON$parse5.listingsearch;
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: label ? 'proje-listeleme' : 'ilan-listeleme',
    ecommerce: {
      impressions: projects.map(function (item) {
        var _item$category, _item$locationInfo, _item$locationInfo2;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(item.name.trim()),
          brand: 'proje',
          variant: item.tradeType.slug,
          list: label ? 'proje-listeleme' : 'ilan-listeleme',
          category: "".concat((_item$category = item.category) === null || _item$category === void 0 ? void 0 : _item$category.slug, "/").concat(item.estateType === null ? '' : _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(item === null || item === void 0 ? void 0 : item.estateType.slug), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_item$locationInfo = item.locationInfo) === null || _item$locationInfo === void 0 ? void 0 : _item$locationInfo.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_item$locationInfo2 = item.locationInfo) === null || _item$locationInfo2 === void 0 ? void 0 : _item$locationInfo2.districtName), "/"),
          position: item.position,
          // label ? parseInt(positions[index], 10) : index + 1
          dimension13: dimension13,
          dimension40: item.createdAt,
          dimension41: getPriceForProjects(item)
        };
      })
    }
  });
};
/*
when clicking on projects in listing listing
*/

var handleListingProjectGtmEvent = function handleListingProjectGtmEvent(event, project, itemIndex, label, isProjectSearch) {
  var _JSON$parse6, _JSON$parse7, _project$category, _project$locationInfo, _project$locationInfo2;

  var dimension13 = isProjectSearch ? (_JSON$parse6 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse6 === void 0 ? void 0 : _JSON$parse6.projectsearch : (_JSON$parse7 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse7 === void 0 ? void 0 : _JSON$parse7.listingsearch;
  event.stopPropagation();
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: label,
    ecommerce: {
      click: {
        actionField: {
          list: "".concat(isProjectSearch ? 'proje' : 'ilan', "-listeleme")
        },
        products: [{
          id: "".concat(project.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(project.name.trim()),
          brand: 'proje',
          variant: project.tradeType.slug,
          category: "".concat((_project$category = project.category) === null || _project$category === void 0 ? void 0 : _project$category.slug, "/").concat(project.estateType === null ? '' : _convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()(project === null || project === void 0 ? void 0 : project.estateType.slug), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_project$locationInfo = project.locationInfo) === null || _project$locationInfo === void 0 ? void 0 : _project$locationInfo.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_1___default()((_project$locationInfo2 = project.locationInfo) === null || _project$locationInfo2 === void 0 ? void 0 : _project$locationInfo2.districtName), "/"),
          position: itemIndex,
          dimension13: dimension13,
          dimension40: project.createdAt,
          dimension41: getPriceForProjects(project)
        }]
      }
    }
  });
};
/*
 Real Estate Initial Event
 */

var agentSearchInitialGTMEvent = function agentSearchInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};

/***/ }),

/***/ "/oVm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("QILm"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _propTypes = _interopRequireDefault(__webpack_require__("17x9"));

var _classnames = _interopRequireDefault(__webpack_require__("TSYQ"));

var _withStyles = _interopRequireDefault(__webpack_require__("Hk+Y"));

var _Typography = _interopRequireDefault(__webpack_require__("6ZaM"));

var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '24px 24px 20px',
    flex: '0 0 auto'
  }
};
exports.styles = styles;

function DialogTitle(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      disableTypography = props.disableTypography,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableTypography ? children : _react.default.createElement(_Typography.default, {
    variant: "title",
    internalDeprecatedVariant: true
  }, children));
}

 false ? undefined : void 0;
DialogTitle.defaultProps = {
  disableTypography: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle);

exports.default = _default;

/***/ }),

/***/ "/xgX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContentText.default;
  }
});

var _DialogContentText = _interopRequireDefault(__webpack_require__("MLHB"));

/***/ }),

/***/ "1xxY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
var getSearchId = function getSearchId(type) {
  return new Promise(function (resolve) {
    var gtmData = localStorage.getItem('EjGtmId');

    if (!gtmData) {
      return null;
    }

    var parsedGtmData = JSON.parse(gtmData);
    return resolve(parsedGtmData[type] || null);
  });
};

/* harmony default export */ __webpack_exports__["default"] = (getSearchId);

/***/ }),

/***/ "5vn7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("QILm"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _propTypes = _interopRequireDefault(__webpack_require__("17x9"));

var _classnames = _interopRequireDefault(__webpack_require__("TSYQ"));

var _withStyles = _interopRequireDefault(__webpack_require__("Hk+Y"));

var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    // Add iOS momentum scrolling.
    padding: '0 24px 24px',
    '&:first-child': {
      paddingTop: 24
    }
  }
};
exports.styles = styles;

function DialogContent(props) {
  var classes = props.classes,
      children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["classes", "children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), children);
}

 false ? undefined : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContent'
})(DialogContent);

exports.default = _default;

/***/ }),

/***/ "C+zi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogTitle.default;
  }
});

var _DialogTitle = _interopRequireDefault(__webpack_require__("/oVm"));

/***/ }),

/***/ "MLHB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _propTypes = _interopRequireDefault(__webpack_require__("17x9"));

var _withStyles = _interopRequireDefault(__webpack_require__("Hk+Y"));

var _Typography = _interopRequireDefault(__webpack_require__("6ZaM"));

// @inheritedComponent Typography
var styles = {
  /* Styles applied to the root element. */
  root: {
    // Should use variant="body1" in v4
    lineHeight: 1.5
  }
};
exports.styles = styles;

function DialogContentText(props) {
  return _react.default.createElement(_Typography.default, (0, _extends2.default)({
    component: "p",
    internalDeprecatedVariant: true,
    variant: "subheading",
    color: "textSecondary"
  }, props));
}

 false ? undefined : void 0;

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText);

exports.default = _default;

/***/ }),

/***/ "SNP2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogContent.default;
  }
});

var _DialogContent = _interopRequireDefault(__webpack_require__("5vn7"));

/***/ }),

/***/ "Sk/v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _DialogActions.default;
  }
});

var _DialogActions = _interopRequireDefault(__webpack_require__("TVBj"));

/***/ }),

/***/ "TVBj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__("TqRt");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__("pVnL"));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__("QILm"));

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _propTypes = _interopRequireDefault(__webpack_require__("17x9"));

var _classnames = _interopRequireDefault(__webpack_require__("TSYQ"));

var _withStyles = _interopRequireDefault(__webpack_require__("Hk+Y"));

var _reactHelpers = __webpack_require__("hD82");

__webpack_require__("1OZW");

// So we don't have any override priority issue.
var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    margin: '8px 4px'
  },

  /* Styles applied to the children. */
  action: {
    margin: '0 4px'
  }
};
exports.styles = styles;

function DialogActions(props) {
  var disableActionSpacing = props.disableActionSpacing,
      children = props.children,
      classes = props.classes,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["disableActionSpacing", "children", "classes", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, className)
  }, other), disableActionSpacing ? children : (0, _reactHelpers.cloneChildrenWithClassName)(children, classes.action));
}

 false ? undefined : void 0;
DialogActions.defaultProps = {
  disableActionSpacing: false
};

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiDialogActions'
})(DialogActions);

exports.default = _default;

/***/ }),

/***/ "XsDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "homeInitialGTMEvent", function() { return homeInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "homeShowcasesGTMEvent", function() { return homeShowcasesGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleHomeShowcasesGTMEvent", function() { return handleHomeShowcasesGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "homePhoneCallGtmEvent", function() { return homePhoneCallGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "homeAddFavoriteGtmEvent", function() { return homeAddFavoriteGtmEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "homeShowcaseProjectGTMEvent", function() { return homeShowcaseProjectGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "handleHomeShowcaseProjectGTMEvent", function() { return handleHomeShowcaseProjectGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favoriteListInitialGTMEvent", function() { return favoriteListInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "favoriteListDetailInitialGTMEvent", function() { return favoriteListDetailInitialGTMEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "homeShowcaseProjectGA4ClickEvent", function() { return homeShowcaseProjectGA4ClickEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "viewProjectsGA4EcommerceEvent", function() { return viewProjectsGA4EcommerceEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "featuredClickGA4Event", function() { return featuredClickGA4Event; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "viewListingItemsGA4EcommerceEvent", function() { return viewListingItemsGA4EcommerceEvent; });
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("kqSB");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("hA9m");
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("joZL");
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_convert_to_url__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("I5Nt");
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_id_creator__WEBPACK_IMPORTED_MODULE_3__);




/*
 Homepage Initial Event
 */

var homeInitialGTMEvent = function homeInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
When homepage and agentsearchpage showcase slider viewed 
 */

var homeShowcasesGTMEvent = function homeShowcasesGTMEvent(showcaseList, label, count) {
  var list = count ? showcaseList.filter(function (item, index) {
    return index === count;
  }) : showcaseList;
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: "".concat(label, "/one-cikan-ilanlar"),
    ecommerce: {
      impressions: list.map(function (item, index) {
        var _item$location, _item$location$city, _item$location2, _item$location2$distr, _item$location3, _item$location3$town, _JSON$parse, _JSON$parse2, _item$price, _item$price$value, _item$priceDetail, _item$priceDetail$pri;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.tradeType || item.tradeTypeName),
          list: "".concat(label, "/one-cikan-ilanlar"),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.category || item.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.estateType || item.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location = item.location) === null || _item$location === void 0 ? void 0 : (_item$location$city = _item$location.city) === null || _item$location$city === void 0 ? void 0 : _item$location$city.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location2 = item.location) === null || _item$location2 === void 0 ? void 0 : (_item$location2$distr = _item$location2.district) === null || _item$location2$distr === void 0 ? void 0 : _item$location2$distr.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location3 = item.location) === null || _item$location3 === void 0 ? void 0 : (_item$location3$town = _item$location3.town) === null || _item$location3$town === void 0 ? void 0 : _item$location3$town.name)),
          position: count ? count + 1 : index + 1,
          dimension13: label === 'ana-sayfa' ? (_JSON$parse = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.homepage : (_JSON$parse2 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse2 === void 0 ? void 0 : _JSON$parse2.agentsearch,
          dimension40: item.createdAt,
          dimension41: ((_item$price = item.price) === null || _item$price === void 0 ? void 0 : (_item$price$value = _item$price.value) === null || _item$price$value === void 0 ? void 0 : _item$price$value.toFixed(2)) || ((_item$priceDetail = item.priceDetail) === null || _item$priceDetail === void 0 ? void 0 : (_item$priceDetail$pri = _item$priceDetail.price) === null || _item$priceDetail$pri === void 0 ? void 0 : _item$priceDetail$pri.toFixed(2))
        };
      })
    }
  });
};
/*
 When clicked homepage and agent search page showcase cards
 */

var handleHomeShowcasesGTMEvent = function handleHomeShowcasesGTMEvent(item, position, label) {
  var _item$location4, _item$location4$city, _item$location5, _item$location5$distr, _item$location6, _item$location6$town, _JSON$parse3, _JSON$parse4, _item$price2, _item$price2$value;

  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: 'ilan-gorsel',
    ecommerce: {
      click: {
        actionField: {
          list: "".concat(label, "/one-cikan-ilanlar")
        },
        products: [{
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.tradeType),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location4 = item.location) === null || _item$location4 === void 0 ? void 0 : (_item$location4$city = _item$location4.city) === null || _item$location4$city === void 0 ? void 0 : _item$location4$city.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location5 = item.location) === null || _item$location5 === void 0 ? void 0 : (_item$location5$distr = _item$location5.district) === null || _item$location5$distr === void 0 ? void 0 : _item$location5$distr.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location6 = item.location) === null || _item$location6 === void 0 ? void 0 : (_item$location6$town = _item$location6.town) === null || _item$location6$town === void 0 ? void 0 : _item$location6$town.name)),
          position: position,
          dimension13: label === 'ana-sayfa' ? (_JSON$parse3 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse3 === void 0 ? void 0 : _JSON$parse3.homepage : (_JSON$parse4 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse4 === void 0 ? void 0 : _JSON$parse4.agentsearch,
          dimension40: item.createdAt,
          dimension41: (_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : (_item$price2$value = _item$price2.value) === null || _item$price2$value === void 0 ? void 0 : _item$price2$value.toFixed(2)
        }]
      }
    }
  });
};
/*
when homepage and agent search page look at phone  clicked
 */

var homePhoneCallGtmEvent = function homePhoneCallGtmEvent(listing, itemIndex, label) {
  var _listing$location, _listing$location$cit, _listing$location2, _listing$location2$di, _listing$location3, _listing$location3$to, _JSON$parse5, _JSON$parse6;

  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: "".concat(label, "/one-cikan-ilanlar"),
    ecommerce: {
      purchase: {
        actionField: {
          list: "".concat(label, "/one-cikan-ilanlar"),
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'telefon-et',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listing.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.tradeType),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.category), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listing.estateType), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location = listing.location) === null || _listing$location === void 0 ? void 0 : (_listing$location$cit = _listing$location.city) === null || _listing$location$cit === void 0 ? void 0 : _listing$location$cit.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location2 = listing.location) === null || _listing$location2 === void 0 ? void 0 : (_listing$location2$di = _listing$location2.district) === null || _listing$location2$di === void 0 ? void 0 : _listing$location2$di.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listing$location3 = listing.location) === null || _listing$location3 === void 0 ? void 0 : (_listing$location3$to = _listing$location3.town) === null || _listing$location3$to === void 0 ? void 0 : _listing$location3$to.name)),
          position: itemIndex + 1,
          quantity: 1,
          dimension13: label === 'ana-sayfa' ? (_JSON$parse5 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse5 === void 0 ? void 0 : _JSON$parse5.homepage : (_JSON$parse6 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse6 === void 0 ? void 0 : _JSON$parse6.agentsearch,
          dimension40: listing.createdAt,
          dimension41: listing.price.value.toFixed(2)
        }]
      }
    }
  });
};
/*
when click add to favorite on homepage and agent search page
*/

var homeAddFavoriteGtmEvent = function homeAddFavoriteGtmEvent(listingItem, itemIndex, label) {
  var _listingItem$location, _listingItem$location2, _listingItem$location3, _listingItem$location4, _listingItem$location5, _listingItem$location6, _JSON$parse7, _JSON$parse8, _listingItem$price, _listingItem$priceDet, _listingItem$priceDet2;

  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'purchase',
    event_label: "".concat(label, "/one-cikan-ilanlar"),
    ecommerce: {
      purchase: {
        actionField: {
          list: "".concat(label, "/one-cikan-ilanlar"),
          id: _id_creator__WEBPACK_IMPORTED_MODULE_3___default()(32),
          affiliation: 'favoriler',
          revenue: '0.00',
          tax: '0.00',
          shipping: '0.00'
        },
        products: [{
          id: "".concat(listingItem.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.title.trim()),
          brand: 'ilan',
          variant: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.tradeType || listingItem.tradeTypeName),
          category: "".concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.category || listingItem.categoryTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(listingItem.estateType || listingItem.estateTypeName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location = listingItem.location) === null || _listingItem$location === void 0 ? void 0 : (_listingItem$location2 = _listingItem$location.city) === null || _listingItem$location2 === void 0 ? void 0 : _listingItem$location2.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location3 = listingItem.location) === null || _listingItem$location3 === void 0 ? void 0 : (_listingItem$location4 = _listingItem$location3.district) === null || _listingItem$location4 === void 0 ? void 0 : _listingItem$location4.name), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_listingItem$location5 = listingItem.location) === null || _listingItem$location5 === void 0 ? void 0 : (_listingItem$location6 = _listingItem$location5.town) === null || _listingItem$location6 === void 0 ? void 0 : _listingItem$location6.name)),
          position: itemIndex + 1,
          quantity: 1,
          dimension13: label === 'ana-sayfa' ? (_JSON$parse7 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse7 === void 0 ? void 0 : _JSON$parse7.homepage : (_JSON$parse8 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse8 === void 0 ? void 0 : _JSON$parse8.agentsearch,
          dimension40: listingItem.createdAt,
          dimension41: ((_listingItem$price = listingItem.price) === null || _listingItem$price === void 0 ? void 0 : _listingItem$price.value.toFixed(2)) || ((_listingItem$priceDet = listingItem.priceDetail) === null || _listingItem$priceDet === void 0 ? void 0 : (_listingItem$priceDet2 = _listingItem$priceDet.price) === null || _listingItem$priceDet2 === void 0 ? void 0 : _listingItem$priceDet2.toFixed(2))
        }]
      }
    }
  });
};
/*
 When project showcase slider viewed
 */

var homeShowcaseProjectGTMEvent = function homeShowcaseProjectGTMEvent(projectList, label, count) {
  if (!(projectList === null || projectList === void 0 ? void 0 : projectList.length)) return;
  var list = projectList.filter(function (item, index) {
    return count === 3 ? index <= count : index === count;
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'impression',
    event_label: "".concat(label, "/one-cikan-projeler"),
    ecommerce: {
      impressions: list === null || list === void 0 ? void 0 : list.map(function (item, index) {
        var _item$category$, _item$category$2, _item$estateType, _item$estateType2, _item$location7, _item$location8, _item$location9, _item$location9$town, _item$category$3, _item$estateType3, _item$location10, _item$location11, _item$location12, _item$location12$town, _JSON$parse9, _JSON$parse10, _item$price3, _item$price4, _item$price5, _item$price$min, _item$price$max;

        return {
          id: "".concat(item.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(item.name.trim()),
          brand: 'proje',
          variant: item.tradeType.slug,
          list: "".concat(label, "/one-cikan-projeler"),
          category: item.category[1] ? "".concat((_item$category$ = item.category[0]) === null || _item$category$ === void 0 ? void 0 : _item$category$.slug, "-").concat((_item$category$2 = item.category[1]) === null || _item$category$2 === void 0 ? void 0 : _item$category$2.slug, "/").concat((item === null || item === void 0 ? void 0 : (_item$estateType = item.estateType) === null || _item$estateType === void 0 ? void 0 : _item$estateType.slug) !== undefined ? item === null || item === void 0 ? void 0 : (_item$estateType2 = item.estateType) === null || _item$estateType2 === void 0 ? void 0 : _item$estateType2.slug : '', "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location7 = item.location) === null || _item$location7 === void 0 ? void 0 : _item$location7.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location8 = item.location) === null || _item$location8 === void 0 ? void 0 : _item$location8.districtName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location9 = item.location) === null || _item$location9 === void 0 ? void 0 : (_item$location9$town = _item$location9.town) === null || _item$location9$town === void 0 ? void 0 : _item$location9$town.name)) : "".concat((_item$category$3 = item.category[0]) === null || _item$category$3 === void 0 ? void 0 : _item$category$3.slug, "/").concat(item === null || item === void 0 ? void 0 : (_item$estateType3 = item.estateType) === null || _item$estateType3 === void 0 ? void 0 : _item$estateType3.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location10 = item.location) === null || _item$location10 === void 0 ? void 0 : _item$location10.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location11 = item.location) === null || _item$location11 === void 0 ? void 0 : _item$location11.districtName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_item$location12 = item.location) === null || _item$location12 === void 0 ? void 0 : (_item$location12$town = _item$location12.town) === null || _item$location12$town === void 0 ? void 0 : _item$location12$town.name)),
          position: count > 3 ? count + 1 : index + 1,
          dimension13: label === 'ana-sayfa' ? (_JSON$parse9 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse9 === void 0 ? void 0 : _JSON$parse9.homepage : (_JSON$parse10 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse10 === void 0 ? void 0 : _JSON$parse10.agentsearch,
          dimension40: item.createdAt,
          dimension41: ((_item$price3 = item.price) === null || _item$price3 === void 0 ? void 0 : _item$price3.min) === '0' && ((_item$price4 = item.price) === null || _item$price4 === void 0 ? void 0 : _item$price4.max) === '0' ? "".concat(parseInt((_item$price5 = item.price) === null || _item$price5 === void 0 ? void 0 : _item$price5.min, 10).toFixed(2)) : "".concat(parseInt((_item$price$min = item.price.min) === null || _item$price$min === void 0 ? void 0 : _item$price$min.split('.').join(''), 10).toFixed(2), " - ").concat(parseInt((_item$price$max = item.price.max) === null || _item$price$max === void 0 ? void 0 : _item$price$max.split('.').join(''), 10).toFixed(2))
        };
      })
    }
  });
};
/*
When clicking the featured projects on the homepage
 */

var handleHomeShowcaseProjectGTMEvent = function handleHomeShowcaseProjectGTMEvent(project, gtmEventLabel, label, actionField) {
  var _project$category$, _project$category$2, _project$estateType, _project$estateType2, _project$location, _project$location2, _project$category$3, _project$estateType3, _project$location3, _project$location4, _JSON$parse11, _JSON$parse12, _project$price, _project$price2, _project$price3, _project$price$min, _project$price$max;

  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'uaEcEvent',
    event_category: 'enhanced-ecommerce',
    event_action: 'click',
    event_label: label,
    ecommerce: {
      click: {
        actionField: {
          list: "".concat(actionField, "/one-cikan-projeler")
        },
        products: [{
          id: "".concat(project.id),
          name: _convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()(project.name.trim()),
          brand: 'proje',
          variant: project.tradeType.slug,
          category: project.category[1] ? "".concat((_project$category$ = project.category[0]) === null || _project$category$ === void 0 ? void 0 : _project$category$.slug, "-").concat((_project$category$2 = project.category[1]) === null || _project$category$2 === void 0 ? void 0 : _project$category$2.slug, "/").concat((project === null || project === void 0 ? void 0 : (_project$estateType = project.estateType) === null || _project$estateType === void 0 ? void 0 : _project$estateType.slug) !== undefined ? project === null || project === void 0 ? void 0 : (_project$estateType2 = project.estateType) === null || _project$estateType2 === void 0 ? void 0 : _project$estateType2.slug : null, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$location = project.location) === null || _project$location === void 0 ? void 0 : _project$location.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$location2 = project.location) === null || _project$location2 === void 0 ? void 0 : _project$location2.districtName), "/") : "".concat((_project$category$3 = project.category[0]) === null || _project$category$3 === void 0 ? void 0 : _project$category$3.slug, "/").concat(project === null || project === void 0 ? void 0 : (_project$estateType3 = project.estateType) === null || _project$estateType3 === void 0 ? void 0 : _project$estateType3.slug, "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$location3 = project.location) === null || _project$location3 === void 0 ? void 0 : _project$location3.cityName), "/").concat(_convert_to_url__WEBPACK_IMPORTED_MODULE_2___default()((_project$location4 = project.location) === null || _project$location4 === void 0 ? void 0 : _project$location4.districtName), "/"),
          position: gtmEventLabel,
          dimension13: actionField === 'ana-sayfa' ? (_JSON$parse11 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse11 === void 0 ? void 0 : _JSON$parse11.homepage : (_JSON$parse12 = JSON.parse(localStorage.getItem('EjGtmId'))) === null || _JSON$parse12 === void 0 ? void 0 : _JSON$parse12.agentsearch,
          dimension40: project.createdAt,
          dimension41: ((_project$price = project.price) === null || _project$price === void 0 ? void 0 : _project$price.min) === '0' && ((_project$price2 = project.price) === null || _project$price2 === void 0 ? void 0 : _project$price2.max) === '0' ? "".concat(parseInt((_project$price3 = project.price) === null || _project$price3 === void 0 ? void 0 : _project$price3.min, 10).toFixed(2)) : "".concat(parseInt((_project$price$min = project.price.min) === null || _project$price$min === void 0 ? void 0 : _project$price$min.split('.').join(''), 10).toFixed(2), " - ").concat(parseInt((_project$price$max = project.price.max) === null || _project$price$max === void 0 ? void 0 : _project$price$max.split('.').join(''), 10).toFixed(2))
        }]
      }
    }
  });
};
/*
 Favorite List Initial Event
 */

var favoriteListInitialGTMEvent = function favoriteListInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
 Favorite List Detail Initial Event
 */

var favoriteListDetailInitialGTMEvent = function favoriteListDetailInitialGTMEvent(id) {
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    search_id: id
  });
};
/*
 When clicking the featured projects on the homepage ga4
 */

var homeShowcaseProjectGA4ClickEvent = function homeShowcaseProjectGA4ClickEvent(_ref) {
  var item = _ref.item,
      index = _ref.index,
      searchId = _ref.searchId;
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'select_item',
    ecommerce: {
      items: Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* generateGa4EcommerceProjectItem */ "c"])({
        item: item,
        index: index,
        searchId: searchId,
        listName: 'anasayfa/one-cikan-projeler'
      })
    }
  });
};
var viewProjectsGA4EcommerceEvent = function viewProjectsGA4EcommerceEvent(_ref2) {
  var items = _ref2.items,
      searchId = _ref2.searchId,
      count = _ref2.count,
      listName = _ref2.listName;
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'view_item_list',
    ecommerce: {
      items: items === null || items === void 0 ? void 0 : items.map(function (item, index) {
        return Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* generateGa4EcommerceProjectItem */ "c"])({
          item: item,
          index: count ? Number(count) : index + 1,
          searchId: searchId,
          listName: listName
        });
      })
    }
  });
};
var featuredClickGA4Event = function featuredClickGA4Event(_ref3) {
  var item = _ref3.item,
      index = _ref3.index,
      searchId = _ref3.searchId,
      listName = _ref3.listName;
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'select_item',
    ecommerce: {
      items: Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* generateGa4EcommerceListingItem */ "b"])({
        item: item,
        index: index,
        searchId: searchId,
        listName: 'anasayfa/one-cikan-ilanlar'
      })
    }
  });
};
var viewListingItemsGA4EcommerceEvent = function viewListingItemsGA4EcommerceEvent(_ref4) {
  var items = _ref4.items,
      searchId = _ref4.searchId,
      listName = _ref4.listName,
      virtualState = _ref4.virtualState,
      count = _ref4.count;
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    ecommerce: null
  });
  Object(___WEBPACK_IMPORTED_MODULE_0__[/* GTMPushEvent */ "a"])({
    event: 'view_item_list',
    ecommerce: {
      items: items === null || items === void 0 ? void 0 : items.map(function (item, index) {
        return Object(_utils__WEBPACK_IMPORTED_MODULE_1__[/* generateGa4EcommerceListingItem */ "b"])({
          item: item,
          index: virtualState ? Number(virtualState[index]) + 1 : Number(count) || index + 1,
          searchId: searchId,
          listName: listName
        });
      })
    }
  });
};

/***/ }),

/***/ "hA9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateGa4EcommerceListingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return generateGa4EcommerceSimilarListingItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return generateGa4EcommerceProjectItem; });
/* unused harmony export generateGa4EcommerceProjectData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generateGa4EcommerceLandListingData; });
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("joZL");
/* harmony import */ var _convert_to_url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_convert_to_url__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("KNqG");
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("I5Nt");
/* harmony import */ var _id_creator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_id_creator__WEBPACK_IMPORTED_MODULE_2__);


 // TODO: Move to constant

var listIds = {
  'ilan-listeleme': 'iLU2nigQGrHn52hO6KkffbwPoVT3KM9j',
  'favori-listesi': '4s4LFZsLbE7FptsE8NTtHzH40ViV97sw',
  'ilan-detay': '5Lge38JIZmHDEInt1crj5dq5g5ZR3761',
  'emlak-ofisi-detay': 'KKb02c9YMCNi47dkFxmLwCWdqdDyaDUc',
  'anasayfa/one-cikan-projeler': '1geiQM8veNB5oXAIORfMn1WLvCDTjvCz',
  'anasayfa/one-cikan-ilanlar': 'rrpM7ESRyuOJ9SOPCrmqNYALsoKDQrsG',
  'anasayfa/vitrin-ilanlari': 'HWqTtQu6RVcCRkPhZo7sB9J9hcnsEZXU',
  'arsa-ilanlari': 'noM0GlIOTBIsRwcrmvw2dFZd00dUVOPw',
  'ilan-detay/benzer-ilanlar': 'bnfJdnKiz7YjoGxKtBCmV1tOeKuva3ke',
  'proje-detay': 'HJ6a7RLbSR2el3KPeAtV7AYNZJ8U21bP',
  'proje-detay/bolgedeki-projeler': '8sJZ2enQlse3XaLtCbPDDrGTwwaKbsjt',
  'ilan-detay/diger-ilanlar': 'qe70KBcu1MKi7Vqs8U8ojkluVonjevXK',
  vitrin: '6qZHBL0bWeWhHaTheVEjAAPPbvzKPX4j',
  'ilan-listeleme/benzer-ilanlar': 'A7b9K1m4Qz8xL2wP0vN5rY6cJ3hD7tF1sV8u',
  'benzer-ilanlar': 'A7b9K1m4Qz8xL2wP0vN5rY6cJ3hD7tF1sV8u'
};
var listIdsForLandPageTabs = {
  'fiyati-dusenler': 'TUyhAFX3QMUMijKSDqb0Li1Ith0mefEO',
  sahibinden: 'KmpVVd7zdOPi6mPgFznDOqJg1iD7rLTR',
  'altyapisi-hazir': 'fp88cOZUYzdnSVc4UmFvWitqpbGbxps0',
  'sanal-turlu-videolu': 'Oaq8Txcecx7B6eecUL3JVUnzfN8CHYBG'
};
var generateGa4EcommerceListingItem = function generateGa4EcommerceListingItem(params) {
  var _item$priceDetail, _item$price, _item$priceDetail2, _item$price2, _item$location, _item$location$city, _item$properties, _item$properties$CATE, _item$location2, _item$location2$distr, _item$properties2, _item$properties2$CIT, _item$location3, _item$location3$town, _item$properties3, _item$properties3$TOW, _item$location4, _item$location4$city, _item$location5, _item$properties4, _item$properties4$CIT;

  var item = params.item,
      index = params.index,
      searchId = params.searchId,
      listName = params.listName,
      affiliation = params.affiliation,
      listIdName = params.listIdName,
      tabName = params.tabName;
  var price = (item === null || item === void 0 ? void 0 : (_item$priceDetail = item.priceDetail) === null || _item$priceDetail === void 0 ? void 0 : _item$priceDetail.price) || (item === null || item === void 0 ? void 0 : (_item$price = item.price) === null || _item$price === void 0 ? void 0 : _item$price.value);
  var getPrice = price || item.price_order;
  var currency = ((_item$priceDetail2 = item.priceDetail) === null || _item$priceDetail2 === void 0 ? void 0 : _item$priceDetail2.currency) || (item === null || item === void 0 ? void 0 : (_item$price2 = item.price) === null || _item$price2 === void 0 ? void 0 : _item$price2.currency) || (item === null || item === void 0 ? void 0 : item.price_order);
  var title = _convert_to_url__WEBPACK_IMPORTED_MODULE_0___default()(item.title.tr) || _convert_to_url__WEBPACK_IMPORTED_MODULE_0___default()(item.title);
  var result = {
    search_id: searchId,
    item_price: item.price_order || (price === null || price === void 0 ? void 0 : price.toFixed(2)) || '0.00',
    item_id: "".concat(item.id),
    item_name: title,
    currency: currency,
    discount: 0.0,
    index: index,
    item_brand: 'ilan',
    item_category: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item.categoryTypeName) || Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item.category) || undefined,
    item_category2: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item.estateTypeName) || Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item.estateType) || undefined,
    item_category3: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_item$location = item.location) === null || _item$location === void 0 ? void 0 : (_item$location$city = _item$location.city) === null || _item$location$city === void 0 ? void 0 : _item$location$city.name) || Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_item$properties = item.properties) === null || _item$properties === void 0 ? void 0 : (_item$properties$CATE = _item$properties.CATEGORY) === null || _item$properties$CATE === void 0 ? void 0 : _item$properties$CATE.slug) || undefined,
    item_category4: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_item$location2 = item.location) === null || _item$location2 === void 0 ? void 0 : (_item$location2$distr = _item$location2.district) === null || _item$location2$distr === void 0 ? void 0 : _item$location2$distr.name) || Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_item$properties2 = item.properties) === null || _item$properties2 === void 0 ? void 0 : (_item$properties2$CIT = _item$properties2.CITY) === null || _item$properties2$CIT === void 0 ? void 0 : _item$properties2$CIT.slug) || undefined,
    item_category5: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_item$location3 = item.location) === null || _item$location3 === void 0 ? void 0 : (_item$location3$town = _item$location3.town) === null || _item$location3$town === void 0 ? void 0 : _item$location3$town.name) || Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_item$properties3 = item.properties) === null || _item$properties3 === void 0 ? void 0 : (_item$properties3$TOW = _item$properties3.TOWN) === null || _item$properties3$TOW === void 0 ? void 0 : _item$properties3$TOW.slug) || undefined,
    item_list_id: listIdName === 'arsa-ilanlari' ? listIdsForLandPageTabs[tabName] : listIds[listName],
    item_list_name: listName,
    item_variant: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item.tradeTypeName) || Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item.tradeType),
    location_id: ((_item$location4 = item.location) === null || _item$location4 === void 0 ? void 0 : (_item$location4$city = _item$location4.city) === null || _item$location4$city === void 0 ? void 0 : _item$location4$city.id) || ((_item$location5 = item.location) === null || _item$location5 === void 0 ? void 0 : _item$location5.cityId) || ((_item$properties4 = item.properties) === null || _item$properties4 === void 0 ? void 0 : (_item$properties4$CIT = _item$properties4.CITY) === null || _item$properties4$CIT === void 0 ? void 0 : _item$properties4$CIT.id),
    price: listIdName === 'arsa-ilanlari' ? '0.00' : getPrice,
    quantity: 1
  };

  if (affiliation) {
    result.affiliation = affiliation;
  }

  return result;
};
var generateGa4EcommerceSimilarListingItem = function generateGa4EcommerceSimilarListingItem(params) {
  var _listing$priceDetail, _listing$priceDetail$, _listing$priceDetail2, _listing$location, _listing$location$cit, _listing$location2, _listing$location2$di, _listing$location3, _listing$location3$to, _listing$location4, _listing$location4$ci;

  var listing = params.listing,
      listName = params.listName,
      index = params.index;
  var getSearchId = JSON.parse(localStorage.getItem('EjGtmId'));
  var searchId = getSearchId.listingsearch;
  var result = [{
    search_id: searchId,
    item_price: (listing === null || listing === void 0 ? void 0 : (_listing$priceDetail = listing.priceDetail) === null || _listing$priceDetail === void 0 ? void 0 : (_listing$priceDetail$ = _listing$priceDetail.price) === null || _listing$priceDetail$ === void 0 ? void 0 : _listing$priceDetail$.toFixed(2)) || '0.00',
    item_id: "".concat(listing.id),
    item_name: _convert_to_url__WEBPACK_IMPORTED_MODULE_0___default()(listing === null || listing === void 0 ? void 0 : listing.title),
    currency: listing === null || listing === void 0 ? void 0 : (_listing$priceDetail2 = listing.priceDetail) === null || _listing$priceDetail2 === void 0 ? void 0 : _listing$priceDetail2.currency,
    discount: 0.0,
    index: index,
    item_brand: 'ilan',
    item_category: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(listing.categoryTypeName) || undefined,
    item_category2: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(listing.estateTypeName) || undefined,
    item_category3: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_listing$location = listing.location) === null || _listing$location === void 0 ? void 0 : (_listing$location$cit = _listing$location.city) === null || _listing$location$cit === void 0 ? void 0 : _listing$location$cit.name) || undefined,
    item_category4: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_listing$location2 = listing.location) === null || _listing$location2 === void 0 ? void 0 : (_listing$location2$di = _listing$location2.district) === null || _listing$location2$di === void 0 ? void 0 : _listing$location2$di.name) || undefined,
    item_category5: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_listing$location3 = listing.location) === null || _listing$location3 === void 0 ? void 0 : (_listing$location3$to = _listing$location3.town) === null || _listing$location3$to === void 0 ? void 0 : _listing$location3$to.name) || undefined,
    item_list_id: listIds[listName],
    item_list_name: 'ilan-listeleme/benzer-ilanlar',
    item_variant: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(listing === null || listing === void 0 ? void 0 : listing.tradeTypeName),
    location_id: (_listing$location4 = listing.location) === null || _listing$location4 === void 0 ? void 0 : (_listing$location4$ci = _listing$location4.city) === null || _listing$location4$ci === void 0 ? void 0 : _listing$location4$ci.id,
    price: 0.0,
    quantity: 1
  }];
  return result;
};

var getPriceForProjects = function getPriceForProjects(item) {
  var price = (item === null || item === void 0 ? void 0 : item.price) || (item === null || item === void 0 ? void 0 : item.priceDetail);
  var data = '0.00';

  if ((price === null || price === void 0 ? void 0 : price.priceVisibility) === 'ASK') {
    data = '0.00';
  } else if ((price === null || price === void 0 ? void 0 : price.priceVisibility) === 'STARTCOUNT') {
    var _price$startPrice;

    data = "".concat(price === null || price === void 0 ? void 0 : (_price$startPrice = price.startPrice) === null || _price$startPrice === void 0 ? void 0 : _price$startPrice.toFixed(2));
  } else if ((price === null || price === void 0 ? void 0 : price.priceVisibility) === 'RANGE') {
    // if (price?.minPrice) {
    //   data = `${price?.minPrice?.toFixed(2)} - ${price?.maxPrice?.toFixed(2)}`;
    // } else if (price?.min) {
    //   data = price.priceSummary;
    // }
    data = price.priceSummary;
  }

  return data;
};

var generateGa4EcommerceProjectItem = function generateGa4EcommerceProjectItem(params) {
  var _item$priceDetail3, _item$price3, _item$currency, _item$category, _item$category2, _item$estateType, _item$tradeType, _item$tradeType2, _location$city;

  var item = params.item,
      index = params.index,
      searchId = params.searchId,
      listName = params.listName;
  var location = (item === null || item === void 0 ? void 0 : item.location) || (item === null || item === void 0 ? void 0 : item.locationInfo) || {};
  var currency = ((_item$priceDetail3 = item.priceDetail) === null || _item$priceDetail3 === void 0 ? void 0 : _item$priceDetail3.currency) || (item === null || item === void 0 ? void 0 : (_item$price3 = item.price) === null || _item$price3 === void 0 ? void 0 : _item$price3.currency) || (item === null || item === void 0 ? void 0 : (_item$currency = item.currency) === null || _item$currency === void 0 ? void 0 : _item$currency.symbol) || (item === null || item === void 0 ? void 0 : item.currency);
  return {
    search_id: searchId,
    item_price: getPriceForProjects(item),
    item_id: item.id,
    item_name: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item === null || item === void 0 ? void 0 : item.title) || Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(item === null || item === void 0 ? void 0 : item.name),
    currency: currency,
    discount: 0.0,
    index: index,
    item_brand: 'proje',
    item_category: Array.isArray(item.category) ? (_item$category = item.category[item.category.length - 1]) === null || _item$category === void 0 ? void 0 : _item$category.slug : (_item$category2 = item.category) === null || _item$category2 === void 0 ? void 0 : _item$category2.slug,
    item_category2: (_item$estateType = item.estateType) === null || _item$estateType === void 0 ? void 0 : _item$estateType.slug,
    item_category3: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(location === null || location === void 0 ? void 0 : location.cityName),
    item_category4: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(location === null || location === void 0 ? void 0 : location.districtName),
    item_category5: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])(location === null || location === void 0 ? void 0 : location.townName) || undefined,
    item_list_id: listIds[listName],
    item_list_name: listName,
    item_variant: Object(_utils_string_utils__WEBPACK_IMPORTED_MODULE_1__[/* slugify */ "i"])((_item$tradeType = item.tradeType) === null || _item$tradeType === void 0 ? void 0 : _item$tradeType.name) || ((_item$tradeType2 = item.tradeType) === null || _item$tradeType2 === void 0 ? void 0 : _item$tradeType2.slug),
    location_id: (location === null || location === void 0 ? void 0 : location.cityId) || (location === null || location === void 0 ? void 0 : (_location$city = location.city) === null || _location$city === void 0 ? void 0 : _location$city.id),
    price: 0.0,
    quantity: 1
  };
};
var generateGa4EcommerceProjectData = function generateGa4EcommerceProjectData(params) {
  var _item$priceDetail4, _item$price4, _item$currency2;

  var item = params.item,
      index = params.index,
      searchId = params.searchId,
      eventName = params.eventName,
      affiliation = params.affiliation,
      listName = params.listName;
  var currency = ((_item$priceDetail4 = item.priceDetail) === null || _item$priceDetail4 === void 0 ? void 0 : _item$priceDetail4.currency) || (item === null || item === void 0 ? void 0 : (_item$price4 = item.price) === null || _item$price4 === void 0 ? void 0 : _item$price4.currency) || (item === null || item === void 0 ? void 0 : (_item$currency2 = item.currency) === null || _item$currency2 === void 0 ? void 0 : _item$currency2.symbol) || (item === null || item === void 0 ? void 0 : item.currency);
  return {
    event: eventName,
    ecommerce: {
      transaction_id: _id_creator__WEBPACK_IMPORTED_MODULE_2___default()(32),
      affiliation: affiliation,
      value: 0.0,
      tax: 0.0,
      shipping: 0.0,
      currency: currency,
      items: [generateGa4EcommerceProjectItem({
        item: item,
        index: index,
        searchId: searchId,
        listName: listName,
        affiliation: affiliation
      })]
    }
  };
};
var generateGa4EcommerceLandListingData = function generateGa4EcommerceLandListingData(params) {
  var item = params.item,
      index = params.index,
      searchId = params.searchId,
      eventName = params.eventName,
      affiliation = params.affiliation,
      listName = params.listName,
      listIdName = params.listIdName,
      tabName = params.tabName;
  return [generateGa4EcommerceListingItem({
    item: item,
    index: index,
    searchId: searchId,
    listName: listName,
    affiliation: affiliation,
    listIdName: listIdName,
    tabName: tabName
  })];
};

/***/ }),

/***/ "jG6q":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"_389e93","small":"_3A5NiX","phoneIcon":"_2z-ya5"};

/***/ })

}]);